import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { configure } from 'axios-hooks';
import { ThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import * as Sentry from '@sentry/browser';

import App from './App';
import { store } from './redux';
import { axiosClient } from './helpers/AxiosClient';
import { theme } from './theme';

import 'moment/locale/it';

Sentry.init({
  dsn: 'https://4b52f749c5a9430fb142f2b2c45e5dad@o310610.ingest.sentry.io/5225683',
  environment: process.env.NODE_ENV,
});

configure({ axios: axiosClient });

const container = document.getElementById('root') as HTMLElement;

ReactDOM.createRoot(container).render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <App />
      </SnackbarProvider>
    </ThemeProvider>
  </Provider>
);
